import React from 'react';
import './styles.scss';
import { FullWidthButton } from '../Button';
import { Trans } from 'react-i18next';

interface TextboxProps {
    headline?: string;
    text: string;
    buttonText: string;
    color: 'blue' | 'neon' | 'white';
    svg?: string;
    centered?: boolean;
    onClick?: () => void;
}

export default function Textbox({ headline, text, buttonText, color, svg, centered, onClick }: TextboxProps): JSX.Element {
    return (
        <article className={`textbox ${color} ${centered ? ' centered' : ''}`}>
            {svg && (
                <svg className='icon-24'>
                    <use xlinkHref={`#${svg}`} />
                </svg>
            )}
            {headline && <h3>{headline}</h3>}
            <p className='body large'>
                <Trans
                    i18nKey={text}
                    components={{
                        strong: <strong />,
                        br: <br />,
                    }}
                />

            </p>
            <FullWidthButton
                type='primary'
                color={`${color === 'blue' ? 'white' : 'blue'}`}
                text={buttonText}
                onClick={onClick}
            />
        </article>
    );
}
